export default "__VITE_ASSET__032ec16c__"